export class ServiceDeleteCommand{
    centerId:string;
    code:string;

    constructor(centerId:string,code:string){
        this.centerId = centerId;
        this.code = code;
    }
}
